import { render, staticRenderFns } from "./BotaoConfiguracaoRastreabilidade.vue?vue&type=template&id=863f27ee&lang=pug"
import script from "./BotaoConfiguracaoRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BotaoConfiguracaoRastreabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports